var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFillFromWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.474,
    height: 13.471,
    viewBox: "0 0 13.474 13.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27286",
    "data-name": "Group 27286",
    transform: "translate(-420.729 -720.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27288",
    "data-name": "Group 27288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_116",
    "data-name": "Subtraction 116",
    d: "M14815.335-5945.517h-4.031a1.3,1.3,0,0,1-1.3-1.3v-3.62l5.323,1.774a1.085,1.085,0,0,0,.365.067,1.05,1.05,0,0,0,.261-.034,4.48,4.48,0,0,0-.678,2.375,4.473,4.473,0,0,0,.062.739Zm.355-3.791a.3.3,0,0,1-.112-.022l-5.576-1.856v-1.086a1.305,1.305,0,0,1,1.3-1.306h2.489v-.473a.95.95,0,0,1,.948-.949h1.9a.95.95,0,0,1,.949.949v.473h2.488a1.308,1.308,0,0,1,1.307,1.306v1.086l-1.315.438c-.112-.006-.208-.01-.292-.01a4.5,4.5,0,0,0-2.926,1.081l-1.044.348A.31.31,0,0,1,14815.69-5949.308Zm-.949-4.744v.473h1.9v-.473Z",
    transform: "translate(-14389.273 6675.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M729.422,1043.994a.425.425,0,0,0,.311-.14l3.018-3.154a.431.431,0,0,0-.311-.729h-1.58v-3.3a.72.72,0,0,0-.718-.718H728.7a.721.721,0,0,0-.718.718v3.3h-1.58a.431.431,0,0,0-.43.432.425.425,0,0,0,.119.3l3.016,3.154A.428.428,0,0,0,729.422,1043.994Z",
    transform: "translate(-298.669 -309.766)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillFromWork);
export default __webpack_public_path__ + "static/media/fill-from-work.25ac70825c0dc40ac011c1038fd0d1f1.svg";
export { ForwardRef as ReactComponent };